<template>
	<Commonlisting
		:search= "false"
		:listingData = "uploadData"
		:headersData = "headers"
		:headerInfo = "headerInfo"
		:inputsListing= "inputs"
		:previous = "previous"
		:next = "next"
		:currentPage = "currentPage"
		:totalPages = "totalPages"
		:totalRecords = "totalRecords"
		:resetFormData= "resetFormData"
		:editFormData= "editFormData"
		:importFile= "false"
		:selectBoxItems= "selectBoxItems"
		:useForms= "true"
		:fileOnly= "fileOnly"
		@previous-page= "pageData"
		@next-page= "pageData"
		@go-to-page= "goTo"
		@view-confirmation= "getUpload"
	/>
</template>
<script>

import Commonlisting from '@/components/generalcomponents/CommonListing';
import UploadsRepository from '@/services/UploadsRepository.vue';
import { pageVariables } from '@/views/insideviews/uploads/PageVariablesUploads';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';

export default {
	name: 'UploadsView',
	async created(){
		this.onlineUser = JSON.parse(window.localStorage.getItem("myUser") || "{}");
		this.pageData(this.page);
	},
	data() {
		return {
			...pageVariables,
			uploadData: [],
			previous: '',
			next: '',
			totalPages: 0,
			totalRecords: 0,
			currentPage: 0,
			resetFormData: false,
			editFormData:{},
			selectBoxItems: [],
			onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
			fileOnly: true
		};
	},
	props: {
	},
	methods: {
		async pageData(page){
			this.loading = true; 
			const uploadsRepo = new UploadsRepository();
			try {
				const response = await uploadsRepo.getUploads(page,this.onlineUser.token,);
				if (response?.status  === 200) {
					this.uploadData = response.data.data;
					this.totalPages = response.data.last_page;
					this.totalRecords = response.data.total;
					this.currentPage = response.data.current_page;

				if (response.data.next_page_url) {
					this.next = response.data.next_page_url;
				}else{
					this.next = ""
				}
				if (response.data.prev_page_url) {

					this.previous = response.data.prev_page_url;
				}else{
					this.previous = ""
				}
				this.loading = false; 

				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error);
			}
		},
		async deleteData(id){
			const uploadsRepo = new UploadsRepository();
			try {
				const response = await uploadsRepo.deleteSegurado(this.page,this.onlineUser.token,id);
				if (response?.status === 204) {
					this.pageData(this.page);

				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error);
			}	
		},
		async getUpload(id){
			console.log(id)
			const uploadsRepo = new UploadsRepository();
			try {
				const response = await uploadsRepo.getUpload(this.page,this.onlineUser.token,id);
				if (response?.status === 200) {
					console.log(response)
					this.editFormData = response.data
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error);
			}	
		},
		goTo(number){
			this.pageData(this.page+"?page="+number)
		},
	},
	components:{
		Commonlisting
	},
	setup() {
	return {
	}
	}}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
